enum RouteEnum {
  Home = "/",
  Dashboard = "/Dashboard",
  Login = "/login",
  Extractpdf ="/invoice",
  Invoice = "/invoice/:id",
  AcceptInvitation = "/accept-invite",
  ForgotPassword = "/forgot-password",
  VerifyPasswordReset = "/forgot-password/verify",
  ResetPassword = "/reset-password",
  MfaRecovery = "/mfa-recovery",
  AdminUsers = "/admin/users",
}

export default RouteEnum;
